// extracted by mini-css-extract-plugin
export default {"root":"PresellPage_root__TpCin"};